<div [class]="appClassWrapper">
  <!--  <app-download-banner></app-download-banner>-->
  <app-header *ngIf="!marketingPage && !hideHeader"></app-header>
  <app-marketing-header *ngIf="marketingPage"></app-marketing-header>
  <main role="main">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="!hideFooter"></app-footer>
</div>
